module.exports = require("lodash/join");